import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Bird, Loader2, KeyRound } from "lucide-react";
import api from "@/lib/api";
import { useAppContext } from "@/App";

export default function PitchMode() {
  const nav = useNavigate();
  const { auth, setAuth } = useAppContext();
  const [status, setStatus] = useState("loading");

  useEffect(() => {
    let cancelled = false;

    async function autoLogin() {
      // If already logged in as pitchdemo, go straight to portal
      if (auth?.user?.email === "pitchdemo@onepigeon.app") {
        nav("/portal");
        return;
      }

      try {
        const res = await api.loginWithPassword("pitchdemo@onepigeon.app", "Love2pitch123*");
        if (cancelled) return;

        const authData = { jwt: res.jwt, user: res.user };
        setAuth(authData);
        localStorage.setItem("pigeon-auth", JSON.stringify(authData));
        setStatus("ready");

        setTimeout(() => { if (!cancelled) nav("/portal"); }, 800);
      } catch (e) {
        if (!cancelled) setStatus("error");
      }
    }

    autoLogin();
    return () => { cancelled = true; };
  }, []);

  return (
    <div className="min-h-[100dvh] bg-slate-950 flex flex-col items-center justify-center p-6">
      <div className="w-20 h-20 bg-red-600 rounded-2xl flex items-center justify-center mb-8 shadow-2xl">
        <Bird className="w-10 h-10 text-white" strokeWidth={1.5} />
      </div>
      <h1 className="text-3xl tracking-tighter text-white mb-3">
        <span className="font-light">Pigeon</span> <span className="font-black">Supply</span>
      </h1>
      {status === "loading" && (
        <div className="flex items-center gap-3 text-slate-400 mt-4">
          <Loader2 className="w-5 h-5 animate-spin" />
          <span className="text-sm font-bold tracking-wide uppercase">Signing in as Pitch Demo...</span>
        </div>
      )}
      {status === "ready" && (
        <p className="text-sm text-green-400 font-bold mt-4 tracking-wide uppercase">Welcome — Opening Hub Portal...</p>
      )}
      {status === "error" && (
        <div className="text-center mt-4">
          <p className="text-sm text-red-400 font-bold mb-3">Could not auto-login. Use sign-in instead.</p>
          <button
            onClick={() => nav("/auth?mode=pitch")}
            className="px-6 py-2 bg-red-600 text-white rounded-xl text-sm font-bold flex items-center gap-2 mx-auto"
          >
            <KeyRound className="w-4 h-4" /> Go to Sign In
          </button>
        </div>
      )}
    </div>
  );
}
